import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import { ADFEncoder, ReactRenderer } from '@atlaskit/renderer';
import React, { memo, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const adfEncoder = new ADFEncoder(schema => new JSONTransformer(schema));

// Only re-render if the prop `text` actually changed
const areEqual = (prev, next) => prev.text === next.text;
export const EditorRenderer = /*#__PURE__*/memo(_ref => {
  let {
    text
  } = _ref;
  // Hook must be called unconditionally per react-hooks/rules-of-hooks
  const rendererDoc = useMemo(() => {
    if (!text) return null;
    try {
      const parsed = JSON.parse(text);
      return adfEncoder.encode(parsed);
    } catch (_unused) {
      // not JSON/ADF → treat as plain text
      return text;
    }
  }, [text]);
  if (!rendererDoc) return null;
  if (typeof rendererDoc === 'string') {
    return /*#__PURE__*/_jsx("p", {
      children: rendererDoc
    });
  }
  return /*#__PURE__*/_jsx(ReactRenderer, {
    document: rendererDoc
  });
}, areEqual);
EditorRenderer.displayName = 'Justification';